<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-lg-6 com-md-6 col-sm-12 d-flex justify-content-start"
          ></div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <select class="form-control">
              <option value="">
                {{ $t('select') }}
              </option>
            </select>
          </div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.branch_name }}</td>
          <td class="kh-font">{{ record.zone_name_kh }}</td>
          <td>{{ record.zone_name_en }}</td>
          <td>{{ record.lattitude }}</td>
          <td>{{ record.longitude }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'study-time-table',
  data() {
    return {
      loading: false,
      columns: [
        { name: this.$t('vehicleZoneProfile.branch') },
        { name: this.$t('vehicleZoneProfile.zoneNameKH') },
        { name: this.$t('vehicleZoneProfile.zoneNameEN') },
        { name: this.$t('vehicleZoneProfile.lattitude') },
        { name: this.$t('vehicleZoneProfile.longitude') },
        { name: this.$t('actions'), style: 'text-align:center; width:1px' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('vehicleZoneProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.vehicleZoneProfile.search
      },
      set(newValue) {
        this.$store.commit('vehicleZoneProfile/SET_SEARCH', newValue)
        this.$store.commit('vehicleZoneProfile/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('vehicleZoneProfile/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('vehicleZoneProfile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'vehicle-zone-profile-edit',
        params: { id: record.zone_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('vehicleZoneProfile/destroy', record.zone_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),

    fetch: function() {
      this.fetchData()
      this.$emit('fetched')
    }
  }
}
</script>
